import Loader from '@components/Loader/Loader';
import { Box } from '@mui/system';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';
import { AnalyticsKeys, IAnalyticData, WidgetType } from 'types/analytics';
import { XY_CHART_ERRORS_THEME } from '../analytics/theme';
import { useAnalytics } from '../analytics/useAnalytics';
import { countAnalyticsFormat, fieldAnalyticsFormat } from '../analytics/utils';
import WidgetCard from './WidgetCard';
import WidgetEmptyState from './WidgetEmptyState';
import WidgetNumeric from './WidgetNumeric';
import WidgetPie from './WidgetPie';
import WidgetXYChart from './WidgetXYChart';

interface IWidgetProps {
	analyticsKey: AnalyticsKeys;
}

const Widget: FC<IWidgetProps> = ({ analyticsKey }) => {
	const { data, isLoading } = useAnalytics(analyticsKey);

	let comp = null;

	const props = {
		analyticsKey
	};

	if (isEmpty(data) || isEmpty((data as IAnalyticData).analytics)) {
		comp = <WidgetEmptyState {...props} />;
	} else {
		switch (analyticsKey) {
			case AnalyticsKeys.ActiveUsers:
			case AnalyticsKeys.NewUsers:
				comp = <WidgetNumeric {...props} items={countAnalyticsFormat(data)} />;
				break;
			case AnalyticsKeys.deviceTypeGraph:
				comp = (
					<WidgetPie {...props} items={fieldAnalyticsFormat('device', data)} />
				);
				break;
			case AnalyticsKeys.activeUsersGraph:
				comp = (
					<WidgetXYChart
						widgetType={WidgetType.Bar}
						items={fieldAnalyticsFormat('action', data)}
					/>
				);
				break;
			case AnalyticsKeys.newUsersGraph:
				comp = (
					<WidgetXYChart
						widgetType={WidgetType.Bar}
						items={fieldAnalyticsFormat('action', data)}
					/>
				);
				break;
			case AnalyticsKeys.errors:
				comp = (
					<WidgetXYChart
						theme={XY_CHART_ERRORS_THEME}
						widgetType={WidgetType.Bar}
						items={fieldAnalyticsFormat('action', data)}
					/>
				);
				break;
			default:
				comp = <WidgetNumeric {...props} items={countAnalyticsFormat(data)} />;
				break;
		}
	}

	return (
		<Box
			display="flex"
			flexGrow={1}
			flexDirection="row"
			data-testid="widget-content"
			maxWidth="100%"
		>
			<WidgetCard title={intl.tr(`analytics.${analyticsKey}`)}>
				<Loader isLoading={isLoading} variant="widget">
					{comp}
				</Loader>
			</WidgetCard>
		</Box>
	);
};

export default Widget;
